module.exports = __webpack_public_path__ + "img/sJokerKing_350x350.6d79eeac.jpg";